import React from "react";
import styled from "styled-components";

function Button({ children, href, icon, onClick }) {
  return (
    <Container>
      <button className="btn notranslate" href={href} onClick={onClick}>
        {children} {icon}
      </button>
    </Container>
  );
}

export default Button;

const Container = styled.div`
  .btn {
    padding: 1.4rem 3.4rem;
    font-size: 1.1rem;
    color: var(--color-white);
    background: var(--color-primary);
    margin: 2rem 0;
    cursor: pointer;
    position: relative;
    z-index: 1;
    font-weight: bold;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }

  .btn:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #111111;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 210ms ease-in;
  }

  .btn:hover::after {
    transform: scaleX(1);
  }
`;
